<template>
    <span
        :class="disabled ? 'module-disabled-struct' : ''"
        :uk-tooltip="
            disabled
                ? 'title:' + $t('x.module.disabled.hint', {x: $t('gallery')})
                : ''
        ">
        <span
            :class="
                disabled ? 'module-disabled uk-height-1-1' : 'uk-height-1-1'
            ">
            <License
                :license-link="settings.licenseLink"
                v-if="isDateStringPast(settings.clickAndBuyLicensedUntil)"
                :licensed-until="settings.clickAndBuyLicensedUntil"
                :description="$t(moduleName)"
                class="uk-margin-medium-bottom"/>
            <div
                v-else-if="!settings.clickAndBuyLicensedUntil"
                class="uk-margin-medium-bottom">
                <InfoBox mode="primary" icon="info">
                    {{
                        $t('x.module.disabled.message', {
                            x: $t(moduleName),
                        })
                    }}
                </InfoBox>
            </div>

            <ul uk-tab="animation: uk-animation-fade">
                <li
                    v-for="tab in ['clickandbuys', 'design', 'license']"
                    :key="tab">
                    <a href="#">{{ $t(tab) }}</a>
                </li>
            </ul>
            <ul class="uk-switcher uk-margin">
                <li>
                    <InfoBox v-if="limitReached" icon="warning" mode="danger">
                        <Translate
                            translation-key="clickandbuy.limit.reached"/>
                    </InfoBox>
                    <div v-if="limitReached" class="uk-margin-medium-top"/>

                    <span
                        :uk-tooltip="
                            'title:' +
                            (limitReached
                                ? $t('clickandbuy.limit.reached')
                                : '')
                        ">
                        <Button
                            :action="actionNew"
                            :is-disabled="limitReached"
                            has-action
                            mode="primary">
                            {{ $t('x.add', {x: $t('clickandbuy')}) }}
                        </Button>
                    </span>

                    <div>
                        {{ settings.clickAndBuys }}
                    </div>

                    <div
                        v-if="
                            settings.clickAndBuys &&
                            settings.clickAndBuys.length > 0
                        ">
                        <span
                            :uk-tooltip="
                                'title:' +
                                (limitReached
                                    ? $t('clickandbuy.limit.reached')
                                    : '')
                            ">
                            <Button
                                :action="actionNew"
                                :is-disabled="limitReached"
                                has-action
                                mode="primary">
                                {{ $t('x.add', {x: $t('clickandbuy')}) }}
                            </Button>
                        </span>
                    </div>
                </li>
                <li>
                    <div
                        class="uk-child-width-1-2@m uk-child-width-1-1 uk-grid-match"
                        uk-grid>
                        <div>
                            <ClickAndBuyTitleForm
                                :text="settings.clickAndBuySettings.title"/>
                        </div>
                        <div>
                            <ClickAndBuyColorForm
                                :text="settings.clickAndBuySettings.color"/>
                        </div>
                    </div>
                </li>
                <li>
                    <div
                        class="uk-child-width-1-2@m uk-child-width-1-1 uk-grid-match"
                        uk-grid>
                        <div
                            v-if="!settings.clickAndBuyLicensedUntil"
                            class="uk-width-1-1">
                            <InfoBox mode="primary" icon="info">
                                {{
                                    $t('x.module.disabled.message', {
                                        x: $t(moduleName),
                                    })
                                }}
                            </InfoBox>
                        </div>
                        <div v-else class="uk-width-1-1">
                            <License
                                :license-link="settings.licenseLink"
                                :licensed-until="
                                    settings.clickAndBuyLicensedUntil
                                "
                                :description="$t(moduleName)"/>
                        </div>
                    </div>
                </li>
            </ul>

            <Modal
                :id="modalIdCreate"
                :title="$t('x.add', {x: $t(moduleName)})">

                <ClickAndBuyForm
                    v-if="selected"
                    :click-and-buy="selected"
                    :disabled="disabled"/>

            </Modal>
        </span>
    </span>
</template>

<script>
import License from '@/components/License.vue';
import InfoBox from '@/components/generic/InfoBox.vue';
import ClickAndBuyTitleForm from '@/views/clickandbuy/ClickAndBuyTitleForm.vue';
import ClickAndBuyColorForm from '@/views/clickandbuy/ClickAndBuyColorForm.vue';
import Translate from '@/components/Translate.vue';
import Button from '@/components/generic/Button.vue';
import UIkit from 'uikit';
import Modal from '@/components/generic/Modal.vue';
import ClickAndBuyForm from "@/views/clickandbuy/ClickAndBuyForm.vue";

export default {
    name: 'ClickAndBuyAdmin',
    components: {
        ClickAndBuyForm,
        Modal,
        Button,
        Translate,
        ClickAndBuyColorForm,
        ClickAndBuyTitleForm,
        InfoBox,
        License,
    },
    data() {
        return {
            moduleName: 'clickandbuy',

            modalIdCreate: 'modal-clickandbuy-create',

            selected: {},
        };
    },
    props: {
        settings: Object,
        disabled: Boolean,
    },
    created() {
    },
    methods: {
        actionNew() {
            // this.actionReset();

            UIkit.modal('#' + this.modalIdCreate).show();
        },
    },
    computed: {
        limitReached() {
            return (
                this.settings.clickAndBuys &&
                this.settings.clickAndBuys.length >=
                this.settings.clickAndBuyInfo.limit
            );
        },
    },
};
</script>

<style lang="scss" scoped></style>
